import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import { tourstartInterface } from './tourstart-interface'

const Tourend = ({ effectUpdateShowTour }: tourstartInterface) => {
	const [showModal, setShowModal] = useState(true)

	return (
		<div>
			<Modal
				onOk={() => {
					setShowModal(false)
					effectUpdateShowTour(false)
				}}
				onCancel={() => {
					setShowModal(false)
					effectUpdateShowTour(false)
				}}
				open={showModal}
				footer={null}
				title={null}
				closable={false}
				centered
				width={'35rem'}
				className='tour-modal tour-end'
			>
				<div>
					<div className='pt-[2.2rem] pb-[1.5rem]'>
						<div className='flex justify-center'>
							<img src="/img/vectors/tourdone.svg" alt="" className='w-[9.2rem] h-[7.9rem]' />
						</div>

						<div className='px-[1.5rem] pt-10 pb-[0.5rem]'>
							<div className='mb-[0.5rem] border-b border-appcolorslightgrey pb-[0.5rem]'>
								<p className='font-semibold text-appcolorblackfaint text-[18px] leading-[22px]'>
									You’re all set!
								</p>
							</div>

							<p className='text-appcolorpurplesix text-base mb-[1.2rem]'>
								You just finished taking the welcome tour and now you’re armed with all the knowledge you need to start your journey!
							</p>

							<div>
								<Button
									className='custom-primary-one-btn white-text smaller-border-radius smaller-padding'
									onClick={() => {
										effectUpdateShowTour(false)
										setShowModal(false)
									}}
								>
									Finish
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default Tourend